import Card, { Header } from "@8x8/oxygen-card";
import { PbxCardProgessBar } from "./styled";

const BLF_MAX_COUNT = 1600;

const PbxBLFCard = (props) => {
  const { pbxName, blfCount, maxOverride, testId } = props;

  const percentFull = (blfCount / (maxOverride ?? BLF_MAX_COUNT)) * 100;
  const percentFullText = `${blfCount} / ${maxOverride ?? BLF_MAX_COUNT}`;
  let statusColor;

  if (percentFull > 90) {
    statusColor = "red";
  } else if (percentFull > 25) {
    statusColor = "orange";
  } else {
    statusColor = "green";
  }

  return (
    <Card
      title={pbxName}
      theme={{
        cardWidth: "300px",
        cardHeight: "fit-content",
        cardBorderRadius: "10px",
      }}
      testId={testId}
    >
      <Header theme={{ cardHeaderLineHeight: "30px" }}>{pbxName}</Header>
      <PbxCardProgessBar
        value={percentFull}
        text={percentFullText}
        fullWidth
        theme={{
          backgroundFiller: statusColor,
          backgroundComplete: statusColor,
          color: statusColor,
        }}
      />
    </Card>
  );
};

export default PbxBLFCard;
